<template>
  <div
    v-if="isLoading"
    :class="classesRoot"
  >
    <ProgressCircular
      :indeterminate="true"
      size="72"
      width="6"
      color="#fff"
    />
  </div>
</template>

<script>
  import ProgressCircular from '@/components/ProgressCircular';

  export default {
    name: 'UiPreloader',
    components: {
      ProgressCircular,
    },
    props: {
      isLoading: {
        type: Boolean,
        default: false,
      },
      isFullscreen: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      classesRoot() {
        const { $style } = this;
        return {
          [$style.root]: true,
          [$style.isFullscreen]: this.isFullscreen,
        };
      },
    },
  };
</script>

<style lang="scss" module>
  .root {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(#000, .7);
    position: absolute;
    @include positionAll(0);
    z-index: 999;

    &.isFullscreen {
      position: fixed;
    }
  }
</style>
